//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BffClientBase {
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface IInkomenClient {
    /**
     * @param inkomensjaar (optional) 
     * @return OK
     */
    geefAanslagbiljetPersonenbelasting_GeefAanslagbiljetPersonenbelasting(insz: string, inkomensjaar?: number | undefined,  cancelToken?: CancelToken): Promise<GeefAanslagbiljetPersonenbelastingResponse>;
    buildInfo_Index( cancelToken?: CancelToken): Promise<FileResponse>;
}

export class InkomenClient extends BffClientBase implements IInkomenClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:59873";

    }

    /**
     * @param inkomensjaar (optional) 
     * @return OK
     */
    geefAanslagbiljetPersonenbelasting_GeefAanslagbiljetPersonenbelasting(insz: string, inkomensjaar?: number | undefined, cancelToken?: CancelToken): Promise<GeefAanslagbiljetPersonenbelastingResponse> {
        let url_ = this.baseUrl + "/api/v1/geefaanslagbiljetpersonenbelasting/{insz}?";
        if (insz === undefined || insz === null)
            throw new globalThis.Error("The parameter 'insz' must be defined.");
        url_ = url_.replace("{insz}", encodeURIComponent("" + insz));
        if (inkomensjaar === null)
            throw new globalThis.Error("The parameter 'inkomensjaar' cannot be null.");
        else if (inkomensjaar !== undefined)
            url_ += "inkomensjaar=" + encodeURIComponent("" + inkomensjaar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefAanslagbiljetPersonenbelasting_GeefAanslagbiljetPersonenbelasting(_response));
        });
    }

    protected processGeefAanslagbiljetPersonenbelasting_GeefAanslagbiljetPersonenbelasting(response: AxiosResponse): Promise<GeefAanslagbiljetPersonenbelastingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeefAanslagbiljetPersonenbelastingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeefAanslagbiljetPersonenbelastingResponse>(null as any);
    }

    buildInfo_Index( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/buildinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBuildInfo_Index(_response));
        });
    }

    protected processBuildInfo_Index(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface GeefAanslagbiljetPersonenbelastingResponse {
    aanslagbiljetPersonenbelasting?: AanslagbiljetPersonenbelastingDto;
    waarschuwingen?: MagdaError[];
}

export interface AanslagbiljetPersonenbelastingDto {
    gevraagdePersoon?: AanslagbiljetPersoonDto;
    gerelateerdePersoon?: AanslagbiljetPersoonDto;
    inkomensjaar?: number;
    artikelnummer?: string;
    items?: ItemDto[];
}

export interface AanslagbiljetPersoonDto {
    insz?: string;
    fiscaleStatus?: FiscaleStatusDto;
}

export interface FiscaleStatusDto {
    code?: string;
    omschrijving?: string;
}

export interface ItemDto {
    code?: string;
    omschrijving?: string;
    waarde?: string;
}

export interface MagdaError {
    message: string | undefined;
    description?: string | undefined;
    externalCode?: string | undefined;
    type?: MagdaErrorType;
}

export enum MagdaErrorType {
    Error = "Error",
    Warning = "Warning",
    Information = "Information",
}

export interface ErrorMessage {
    type?: string | undefined;
    title: string;
    status?: number;
    detail: string;
    instance?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}